import { render, staticRenderFns } from "./BoxingInvoicePrint.vue?vue&type=template&id=8f1687f0&scoped=true&"
import script from "./BoxingInvoicePrint.vue?vue&type=script&lang=js&"
export * from "./BoxingInvoicePrint.vue?vue&type=script&lang=js&"
import style0 from "./BoxingInvoicePrint.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BoxingInvoicePrint.vue?vue&type=style&index=1&id=8f1687f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f1687f0",
  null
  
)

export default component.exports